import axiosInstance from "../../axiosInstance";
import { CHECK_APPOINTMENT_FAIL, CHECK_APPOINTMENT_REQUEST, CHECK_APPOINTMENT_SUCCESS, CHECK_APPOINTMENT_RESET } from "../constants/checkAppointment";
import { baseUrl } from "./baseUrl";
import axios from "axios";


const checkAppointment = (patient) => async (dispatch) => {
    try {
        dispatch({
            type: CHECK_APPOINTMENT_REQUEST,
        });
        const { data } = await axiosInstance.get(
            `/visits/appointments/check?patient=${patient}`
        );
        console.log('data visits', data);
        dispatch({
            type: CHECK_APPOINTMENT_SUCCESS,
            payload: data.data,
        });
    } catch (err) {
        let message =
            err.response && err.response.data.message
                ? err.response.data.message
                : err.message;
        dispatch({
            type: CHECK_APPOINTMENT_FAIL,
            payload: message,
        });
    }
};

const resetCheckAppointment = () => (dispatch) => {
    dispatch({
        type: CHECK_APPOINTMENT_RESET,
    });
};

export { checkAppointment, resetCheckAppointment }
